import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../index';
import i18n from '../i18n';
let stripeCheckout;
let stripePromise;
const stripeLanguageMap = {
    "en-us": "en",
    "en-gb": "en-GB",
    "en-ca": "en",
    "en-au": "en",
    "zh-cn": "zh",
    "zh-tw": "zh-TW",
    "zh-hk": "zh-HK",
    "es-es": "es",
    "es-mx": "es-419",
    "es-co": "es-419",
    "es-ar": "es-419",
    "hi": "auto",
    "ar-sa": "auto",
    "ar-eg": "auto",
    "ar-ae": "auto",
    "ar-ma": "auto",
    "pt-br": "pt-BR",
    "pt-pt": "pt",
    "bn": "auto",
    "bn-in": "auto",
    "ru": "ru",
    "ja": "ja",
    "ko": "ko",
    "pa-in": "auto",
    "pa-pk": "auto",
    "jv": "auto",
    "te": "auto",
    "ta": "auto",
    "ta-lk": "auto",
    "ur-pk": "auto",
    "ur-in": "auto",
    "vi": "vi",
    "ms-my": "ms",
    "ms-id": "ms",
    "ha-ng": "auto",
    //"ha-ne": "auto",
    "am": "auto",
    "my": "auto",
    "th": "th",
    "ne": "auto",
    "km": "auto",
    "fr-fr": "fr",
    "fr-ca": "fr-CA",
    "de-de": "de",
    "de-at": "de",
    "de-ch": "de",
    "it-it": "it",
    "it-ch": "it",
    "nl-nl": "nl",
    "nl-be": "nl",
    "pl": "pl",
    "tr": "tr",
    "uk": "auto",
    "el": "el",
    "sv": "sv"
};
const UpgradeToPro = () => {
    const { products, canTrial, isProBusiness, isPro, isPremium, setJustUpgraded, justUpgraded, t } = useContext(AppContext);
    // State to manage selected plan for all sections
    const [selectedPlan, setSelectedPlan] = useState('monthly');
    const [useTrial, setUseTrial] = useState(true);
    const [showLoader, setShowLoader] = useState(false);
    const [showStripe, setShowStripe] = useState(false);
    const navigate = useNavigate();
    const handlePlanChange = (plan) => {
        setSelectedPlan(plan);
    };
    useEffect(() => {
        if (location.pathname.indexOf('upgrade') > -1) {
            setShowStripe(false);
            if (stripeCheckout) {
                stripeCheckout.destroy();
                stripeCheckout = null;
            }
        }
    }, [location.pathname]);
    const closeClick = () => {
        console.log("click");
        setShowStripe(false);
        navigate('/upgrade');
    };
    const handleCheckout = async (plan, planName, trial) => {
        if (plan == 'pass') {
            window['valueUSD'] = 24.99;
        }
        else if (plan == 'monthly') {
            window['valueUSD'] = planName == 'basic' ? 19 : 100;
        }
        else if (plan == 'yearly') {
            window['valueUSD'] = planName == 'basic' ? 168 : 1080;
        }
        if (!stripePromise) {
            stripePromise = import('@stripe/stripe-js').then(({ loadStripe }) => loadStripe(window.stripeKey));
        }
        setShowLoader(true);
        var isLocalHost = window.location.hostname.indexOf('localhost') != -1;
        var domain = isLocalHost ? 'localhost:44309' : 'api.scribblemaps.com';
        let types = {
            'business': {
                'monthly': 'proBusinessMonthly',
                'yearly': 'proBusinessYearly'
            },
            'businessTrial': { 'monthly': 'proBusinessMonthlyTrial',
                'yearly': 'proBusinessYearlyTrial' },
            'basic': {
                'monthly': 'monthly',
                'yearly': 'yearly'
            },
            'basicTrial': {
                'monthly': 'monthlyTrial',
                'yearly': 'yearlyTrial',
            },
            'pass': {
                'pass': 'weekPass'
            }
        };
        let type = types[trial ? planName + 'Trial' : planName][plan];
        var isLocalHost = window.location.hostname.indexOf('localhost') != -1;
        var domain = isLocalHost ? 'localhost:44309' : 'api.scribblemaps.com';
        if (stripeCheckout) {
            stripeCheckout.destroy();
            stripeCheckout = null;
        }
        fetch('https://' + domain + '/api/subscribe/checkout?source=lite&lang=' + (stripeLanguageMap[i18n.language] || 'auto') + '&type=' + type, { credentials: 'include' })
            .then(function (response) {
            return response.json();
        }).then(function (data) {
            var clientSecret = data.clientSecret;
            var sessionId = data.sessionId;
            setTimeout(() => {
                stripePromise.then((stripe) => {
                    stripe
                        .initEmbeddedCheckout({
                        clientSecret,
                        onComplete: () => {
                            fetch(`https://${domain}/api/subscribe/validateSession?sessionId=${sessionId}`, {
                                credentials: 'include',
                            }).then(() => {
                                if (stripeCheckout) {
                                    stripeCheckout.destroy();
                                    stripeCheckout = null;
                                }
                                setShowStripe(false);
                                navigate("/", { replace: true });
                                window.FeatureTracking.upgrade(window['valueUSD']);
                                setJustUpgraded(true);
                            });
                        },
                    })
                        .then((checkout) => {
                        stripeCheckout = checkout.embeddedCheckout;
                        checkout.mount('#stripeEmbed');
                        setShowStripe(true);
                        setShowLoader(false);
                    });
                });
            }, 0);
        }).catch(function (error) {
            setShowLoader(false);
            setShowStripe(false);
            console.log('Error:', error);
            navigate('/upgrade');
        });
    };
    return (<div className='upgradeToPro'>
    {showLoader && <div className='loader'></div>}
  
    <div className="trialInfo">
      {useTrial && canTrial(products) ? <h3>{t('upgrade_to_pro.start_trial')}</h3> : <h3>{t('upgrade_to_pro.upgrade_to_pro')}</h3>}
      <p><a href="https://help.scribblemaps.com/hc/en-us/articles/9054621548813-Cancel-Subscription" target='_blank'>{t('upgrade_to_pro.cancel_anytime')}</a></p>
      <p className='seatInfo'><a href='https://team.scribblemaps.com' target="_blank">{t('upgrade_to_pro.need_team_seats')}</a></p>
    </div>
  
    <div className='upgradeOptions' style={{ display: showStripe ? 'none' : 'flex' }}>
      {!isPro(products) && <div className='option'>
        <div className='title'>{t('upgrade_to_pro.pro_basic')}</div>
        <div className='optionInfo'>
        <ul className='features'>
          <li>{t('upgrade_to_pro.features.access_pro_lite')}</li>
          <li>{t('upgrade_to_pro.features.unlimited_maps')}</li>
          <li>{t('upgrade_to_pro.features.unlimited_street_view')}</li>
          <li>{t('upgrade_to_pro.features.overlay_management')}</li>
          <li>{t('upgrade_to_pro.features.import_visualizations')}</li>
          <li>{t('upgrade_to_pro.features.geocodes_per_month.basic')}</li>
          <li>{t('upgrade_to_pro.features.image_storage.basic')}</li>
          <li>{t('upgrade_to_pro.features.image_export.basic')}</li>
          <li>{t('upgrade_to_pro.features.sell_map_access')} <br />(<a href='https://www.scribblemaps.com/maps/view/paid-example-map/paidsample' target='_blank'>{t('upgrade_to_pro.features.view_example')}</a>)</li>
        </ul>
  
        <div className="planOptions">
          <h2>{t('upgrade_to_pro.features.header')}</h2>
  
          {canTrial(products) && <div className='trialOption'>
          <label>
            <input type="checkbox" checked={!useTrial} onChange={() => setUseTrial(!useTrial)}/>
            {t('upgrade_to_pro.skip_trial')}
          </label>
        </div>}
  
          <div className="planOption">
            <label>
              <input type="radio" name="proBasicPlan" value="monthly" checked={selectedPlan === 'monthly'} onChange={() => handlePlanChange('monthly')}/>
              <strong>{t('upgrade_to_pro.monthly_plan')}</strong>
            </label>
  
            <label>
              <input type="radio" name="proBasicPlan" value="yearly" checked={selectedPlan === 'yearly'} onChange={() => handlePlanChange('yearly')}/>
              <strong>{t('upgrade_to_pro.yearly_plan')}</strong>
            </label>
          </div>
        </div>
  
        <button className="checkoutButton" onClick={() => handleCheckout(selectedPlan, 'basic', canTrial(products) && useTrial)}>
          {useTrial && canTrial(products) ? t('upgrade_to_pro.start_trial_button') : t('upgrade_to_pro.checkout_now')}
        </button>
        </div>
      </div>}
  
      {!isProBusiness(products) && <div className='option business'>
        <div className='title'>{t('upgrade_to_pro.pro_business')}</div>
        <div className='optionInfo'>
        <ul className='features'>
          <li>{t('upgrade_to_pro.features.access_pro_lite')}</li>
          <li>{t('upgrade_to_pro.features.data_connectors')}</li>
          <li>{t('upgrade_to_pro.features.bi_charting')}</li>
          <li>{t('upgrade_to_pro.features.route_optimization')}</li>
          <li>{t('upgrade_to_pro.features.usa_parcel_demo_data')}</li>
          <li>{t('upgrade_to_pro.features.onboarding_sla')}</li>
          <li>{t('upgrade_to_pro.features.geocodes_per_month.business')}</li>
          <li>{t('upgrade_to_pro.features.image_storage.business')}</li>
          <li>{t('upgrade_to_pro.features.branding')}</li>
          <li>{t('upgrade_to_pro.features.image_export.business')}</li>
        </ul>
  
        <div className="planOptions">
          <h2>{t('upgrade_to_pro.features.header')}</h2>
  
          {canTrial(products) && <div className='trialOption'>
            <label>
              <input type="checkbox" checked={!useTrial} onChange={() => setUseTrial(!useTrial)}/>
              {t('upgrade_to_pro.skip_trial')}
            </label>
          </div>}
  
          <div className="planOption">
            <label>
              <input type="radio" name="proBusinessPlan" value="monthly" checked={selectedPlan === 'monthly'} onChange={() => handlePlanChange('monthly')}/>
              <strong>{t('upgrade_to_pro.monthly_plan_business')}</strong>
            </label>
  
            <label>
              <input type="radio" name="proBusinessPlan" value="yearly" checked={selectedPlan === 'yearly'} onChange={() => handlePlanChange('yearly')}/>
              <strong>{t('upgrade_to_pro.yearly_plan_business')}</strong>
            </label>
          </div>
        </div>
  
        <button className="checkoutButton" onClick={() => handleCheckout(selectedPlan, 'business', canTrial(products) && useTrial)}>
          {useTrial && canTrial(products) ? t('upgrade_to_pro.start_trial_button') : t('upgrade_to_pro.checkout_now')}
        </button>
        </div>
      </div>}
  
      {(!isPremium(products) && !isPro(products)) && <div className='option daypass'>
      <div className='title'>{t('upgrade_to_pro.pro_day_pass')}</div>
      <div className='optionInfo'>
        <ul className='features'>
          <li>{t('upgrade_to_pro.features.access_pro_lite')}</li>
          <li>{t('upgrade_to_pro.features.day_pass_features')}</li>
          <li>{t('upgrade_to_pro.features.pay_local_currency')}</li>
          <li>{t('upgrade_to_pro.features.generate_posters')}</li>
        </ul>
  
        <h2 className='payOnce'>{t('upgrade_to_pro.pay_once')}</h2>
  
        <button className="checkoutButton" onClick={() => handleCheckout('pass', 'pass')}>
          {t('upgrade_to_pro.checkout_now')}
        </button>
        </div>
      </div>}
    </div>
    <div className='stripeEmbedWrapper' id='stripeEmbedWrapper' style={{ display: showStripe && !justUpgraded ? 'block' : 'none' }}>
      <div className='stripeEmbed' id='stripeEmbed'></div>
      <div className='close' onClick={closeClick}></div>
    </div>
  </div>);
};
export default UpgradeToPro;
